export default "__VITE_ASSET__CRbtcnDr__"